import { useEffect, useState } from "react";

export const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = useState(() => targetDate - new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(targetDate - new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const totalSeconds = Math.floor(timeLeft / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds };
};
